<template>
  <b-overlay :show="busy" rounded="sm">
    <b-card class="border-none py-0 mb-0 no-margin px-1">
      <b-card-header class="py-1 mb-2">
        <i :class="carbonsegments.icon" class="text-primary mr-1"></i>
        <span>Import</span>
      </b-card-header>

      <b-card-body class="py-0">
        <div>
          <b-row>
            <b-col cols="12" sm="6" md="6" xl="6">
              <b-form-group label="Click x to remove or browse for document upload..." label-size="sm">
                <b-input-group>
                  <!-- :disabled="item.data ? false : true" -->
                  <b-input-group-prepend>
                    <b-button size="sm" title="delete" variant="outline-danger" @click="fileUpload_clear">
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-prepend>
                  <b-form-file class="ml-1 z-0" id="file-small" size="sm" ref="file-input" :multiple="false" no-drop
                    @change="fileUpload_selected" :placeholder="fileUpload ? fileUpload.name : 'No file chosen'
                      " :disabled="fileUpload ? true : false"></b-form-file>
                  <b-input-group-append>
                    <b-button class="ml-1" size="sm" title="view file" variant="outline-primary" @click="fileUpload_view"
                      :disabled="!fileUpload">
                      <i class="fa fa-download"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="6" md="4" xl="3">
              <b-row>
                <b-col>
                  <b-form-group label="Type" label-for="type" label-cols="12">
                    <treeselect instanceId="type" type="number" v-model="item.type" :clearable="true"
                      :options="type_options" :disabled="true"></treeselect>
                  </b-form-group></b-col>
                <b-col>
                  <b-form-group label="Size" label-for="size" label-cols="12">
                    <b-input-group>
                      <b-form-input type="text" v-model="item.size" placeholder="Enter size" size="sm"
                        :disabled="true"></b-form-input>
                      <!-- <b-input-group-append>
                        <b-button size="sm" variant="outline-secondary" @click="item.size = ''" :disabled="true">
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append> -->
                    </b-input-group> </b-form-group></b-col>

              </b-row>
            </b-col>
            <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group label="Source" label-for="sourcetype" label-cols="12">
                <b-form-input v-model="sourcetype" size="sm" :disabled="true" placeholder="Not detected">
                </b-form-input>
                <!-- <treeselect instanceId="sourcetype" type="number" v-model="sourcetype" :clearable="true" :multiple="false"
                  :options="sourcetype_options" :disabled="true" placeholder="Not detected"></treeselect> -->
              </b-form-group>
            </b-col>
          </b-row>
        </div>
        <b-overlay :show="busy" spinner-type="grow" spinner-variant="primary" rounded="sm">

          <r-table :refid="carbonsegments.refid" :busy="carbonsegments.busy" :icon="carbonsegments.icon" :showtoolbar="true"
            :showsheets="true" :showpages="false" :showfab="false" :tools="carbonsegments.tools"
            :toolbar="carbonsegments.toolbar" :fields="carbonsegments.fields" :items="carbonsegments.items"
            :dirty="carbonsegments.dirty" @click="carbonsegments_click" @select="carbonsegments_select" />
        </b-overlay>

      </b-card-body>

      <b-card-footer class="nopadding mt-2">
        <b-row no-gutters>
          <b-col cols="auto" class="text-left">
            <b-button squared size="sm" variant="primary" :disabled="fileUpload && sourcetype != 'Sheet1' ? false : true"
              @click="importit">
              <i class="fa fa-check"></i>
              Import It
            </b-button>
          </b-col>
          <b-col class="text-left ml-2 mt-1">
            <div v-if="busy">
              <i class="fa fa-spinner fa-spin text-primary"></i>
            </div>
            <div v-else>
              <span v-html="message"></span>
            </div>
          </b-col>
          <b-col class="text-right" cols="8">
            <b-button squared size="sm" variant="secondary" @click="discard">
              <i class="fa fa-chevron-left pr-1"></i>
              Back
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>

    </b-card>
  </b-overlay>
</template>
  
<script>
import gql from "graphql-tag";


export default {
  name: "CarbonSegmentImport",
  data() {
    return {
      busy: false,
      posted: true,
      readonly: false,
      message: null,
      message_sheet: null,
      upload: null,
      type_options: [
        { id: 0, label: "File" },
        { id: 1, label: "File folder" },
      ],
      sourcetype: "CARBON",
      state: null,
      sourcetype_options: [
        { id: "0", label: "Bulkticket0" },
        { id: "1", label: "Bulkticket1" },
        { id: "2", label: "BarclayCard" },
        { id: "3", label: "ConfermaPay" },
      ],
      carbonsegments: {
        title: "Carbon Segments Import",
        icon: "fa fa-upload",
        debounce: 500,
        busy: false,
        dirty: false,
        page: 1,
        tools: "go,export,clipboard,textsize,sheet_1",
        toolbar: [],
        fields: [],
        items: []
      },
      item: {
      },
    };
  },
  computed: {
    activesheet() {
      return this.carbonsegments
    }
  },
  watch: {
    fileUpload: {
      immediate: true,
      deep: true,
      async handler(newVal, oldVal) {
        this.message = ""
        this.activesheet.fields = [];
        this.activesheet.items = [];
        this.item.type = 0;
        if (newVal) {
          this.item.name = newVal.name;
          this.item.size = newVal.size;
          await this.preview(JSON.stringify(newVal));
        } else {
          this.item.name = null;
          this.item.size = 0;
        }
      },
    },
    "item.name": {
      async handler(newVal, oldVal) {
        if (this.fileUpload) {
          this.fileUpload.name = newVal;
        }
      },
    },
  },
  methods: {
    async preview(data) {
      this.activesheet.busy = true;

      let variables = {
        data: JSON.stringify(this.fileUpload),
        state: this.state,
        type: this.sourcetype
      };

      try {
        const response = await this.$apollo.query({
          query: gql`
            query file_preview($data: String, $state: String, $type: String) {
              file_preview(data: $data, state: $state, type: $type) {
                sheet
                fields
                items
              }
            }
          `,
          variables,
        });

        this.sheets = response.data.file_preview
        this.activesheet.fields = JSON.parse(response.data.file_preview[0].fields);
        this.activesheet.items = JSON.parse(response.data.file_preview[0].items);
        this.activesheet.loaded = this.activesheet.items
        let find = this.activesheet.toolbar.find((o) => o.action == "sheet_1");
        if (find) {
          find.label = response.data.file_preview[0].sheet
        }
        this.posted = false


      } catch (error) {
        console.log(error);
      }
      this.activesheet.busy = false;
    },
    async importit() {

      this.activesheet.busy = true;

      let variables = {
        rows: this.cleanit(this.sheets),
        apply: true
      };

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
                                mutation carbonsegments_import($rows: [FilePreview_input], $apply: Boolean) {
                                  carbonsegments_import(rows: $rows, apply: $apply) {
                                        sheet
                                        fields
                                        items
                                        type
                                    }
                                }
                        `,
          variables,
        });
        this.message = "<span class='text-primary'>Imported it.</span>";

        this.sheets = response.data.carbonsegments_import
        this.activesheet.fields = JSON.parse(response.data.carbonsegments_import[0].fields);
        this.activesheet.items = JSON.parse(response.data.carbonsegments_import[0].items);
        let find = this.activesheet.toolbar.find((o) => o.action == "sheet_1");
        if (find) {
          find.label = response.data.carbonsegments_import[0].sheet
        }
        this.posted = true

      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }


      this.activesheet.busy = false;
    },
    async carbonsegments_click(a, ss) {

      switch (a) {
        case "filter":
          this.showfilter = !this.showfilter;
          break;
        case "discard":
        case "go":
          this.component = null;
          this.preview();
          break;
      }
    },
    async carbonsegments_select(ss, tools) {

      let state = this.carbonsegments;

      state.selected = ss;
      let tool = null;

      if (tools) {
        let enabled = [
          "back",
          "save",
          "go",
          "filter",
          "textsize",
          "export",
          "download",
          "clipboard",
        ];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });

        if (!state.denied) {
          state.denied = [];
        }
        state.denied.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.visible = false;
          }
        });
      }
    },
  },
};
</script>
  
<style></style>